import BillingInformationForm from '../../../billingInformations/components/BillingInformationForm';

const BillingInformationStep = ({ informationFormId, nextStep }: { informationFormId: string, nextStep?: () => void }) => {

    return (
        <>            
            <BillingInformationForm informationFormId={informationFormId} nextStep={nextStep}/>
        </>
    )
}

export default BillingInformationStep